/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';

import CheckCircleImage from '../assets/images/check-circle.svg';
import { color, margins, paddings, fontSize } from '../ui/utils';

const TextStyles = styled.div`
  ${(props) => fontSize(props.fontSize)};
  ${(props) => margins(props)};
  ${(props) => paddings(props)};

  p {
    margin-bottom: ${({ theme }) => theme.spacing.baseUnit};
    ${(props) => color(props.color)};
    ${({ textAlign }) => map(textAlign, (val) => `text-align: ${val};`)};
    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'inherit')};

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: ${({ theme }) => theme.fontWeights.bold};
  }

  em {
    font-style: italic;
  }

  h2 {
    font-size: ${({ theme }) => theme.spacing.baseUp6};
  }

  h3 {
    font-size: ${({ theme }) => theme.spacing.baseUp4};
    ${(props) => color(props.color)};
  }

  h4 {
    font-size: ${({ theme }) => theme.spacing.baseUp2};
    color: ${({ theme }) => theme.colors.coral};
  }

  h5 {
    ${(props) => color(props.color)};
  }

  h6 {
    ${(props) => color(props.color)};
  }

  ul {
    list-style-type: ${({ listStyle }) =>
      listStyle === 'default' ? 'disc' : 'none'};
    ${(props) => color(props.color)};
    padding-left: ${({ theme }) => theme.spacing.baseUnit};

    li {
      position: relative;
      margin-bottom: ${({ theme }) => theme.spacing.baseDown2};

      &:before {
        content: '';
        position: absolute;
        display: ${({ listStyle }) =>
          listStyle !== 'default' ? 'block' : 'none'};
        top: 3px;
        left: -${({ theme }) => theme.spacing.baseUp2};
        height: ${({ theme }) => theme.spacing.baseUnit};
        width: ${({ theme }) => theme.spacing.baseUnit};
        background-image: url(${CheckCircleImage});
        background-size: ${({ theme }) => theme.spacing.baseUnit};
        background-repeat: no-repeat;

        ${breakpoint('tablet')`
          left: -${({ theme }) => theme.spacing.baseUp4};
          height: ${({ theme }) => theme.spacing.baseUp2};
          width: ${({ theme }) => theme.spacing.baseUp2};
          background-size: ${({ theme }) => theme.spacing.baseUp2};
        `};
      }
    }
  }
`;

const RichTextHtml = ({ html, ...props }) => (
  <TextStyles dangerouslySetInnerHTML={{ __html: html }} {...props} />
);

RichTextHtml.defaultProps = {
  listStyle: 'default',
};

RichTextHtml.propTypes = {
  html: PropTypes.string.isRequired,
  listStyle: PropTypes.string,
};

export default RichTextHtml;
